<template>
  <customFieldsAddingPreview
    :icon='"pencil2.svg"'
    :name="preloadedItem.name || 'Large Text Box'">

    <template :slot='"body"'>
      <v-textarea
        dense
        :label="preloadedItem.placholder"
        :placeholder="preloadedItem.placholder"
        persistent-placeholder
        v-model="value"
        color="#43425d"
        maxlength="128"
        rows="1"
        class="r-field item-name-field"/>
    </template>
  </customFieldsAddingPreview>
</template>

<script>
import customFieldsAddingPreview from '../customFieldsAddingPreview'
export default {
  props: {
    preloadedItem: {
      type: Object,
      default: () => {
        return {
          name: '',
          placeholder: '',
          defaultValue: null
        }
      }
    }
  },
  data: function () {
    return {
      value: this.preloadedItem.defaultValue
    }
  },
  watch: {
    'preloadedItem.defaultValue': {
      handler (newDefaultValue, oldDefaultValue) {
        if (this.value === oldDefaultValue) {
          this.value = newDefaultValue
        }
      },
      deep: true
    }
  },
  components: {
    customFieldsAddingPreview
  }
}
</script>
